import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VLLMChatModelTypeArr } from '@shared/index';
import { firstValueFrom } from 'rxjs';
import { EventManagerAdminService } from '../../event-manager/event-manager-admin.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';

@Injectable({ providedIn: 'root' })
export class VllmAdminService {
  constructor(
    private eventManager: EventManagerAdminService,
    private http: HttpClient,
    private botIdService: BotidService) { }

  private async _complexCompletion(modelConf: { model: string }, promptInput: string, llmType: string, jsonResponse: boolean) {
    this.eventManager.triggerEventHook("io_out_chatcompletion_start", { modelConf, promptInput, llmType, jsonResponse });
    const result = await firstValueFrom(this.http.post("/api/toolbox/completion/create/" + llmType + "/" + this.botIdService.getBotId(),
      {
        modelConf,
        promptInput,
        jsonResponse
      }
    ));
    this.eventManager.triggerEventHook("io_in_chatcompletion_end", { modelConf, promptInput, llmType, jsonResponse, result });
    return result;
  }

  public async chatCompletion(input: string) {
    const modelConf = {
      model: VLLMChatModelTypeArr[0]
    };
    this.eventManager._trigger_RAGAI_EVENT("RAGAI.AITEXT_VLLM.CHATCOMPLETION.request", { request: { modelConf, promptInput: input } });
    const result = await this._complexCompletion(modelConf, input, "vllm", false);
    this.eventManager._trigger_RAGAI_EVENT("RAGAI.AITEXT_VLLM.CHATCOMPLETION.result", { result, request: { modelConf, promptInput: input } });
    return result;
  }

  public async chatCompletionJson(input: string) {
    const modelConf = {
      model: VLLMChatModelTypeArr[0]
    };
    return this._complexCompletion(modelConf, input, "vllm", true);
  }
}
